// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"oneWayInterviewConfiguration_navigateBtnCol__rzQ+W","dividerLine":"oneWayInterviewConfiguration_dividerLine__5Wm+1"};